// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
import React from 'react';
import zutil from 'zutil';

const get_photo = user=>{
    let uid, photo = zutil.get(user, 'photos.0.value');
    if (!photo && (uid = zutil.get(user, 'providers.facebook.hola_uid')))
    {
        const id = uid.slice(9);
        // XXX evgeniy: replace to configurable token?
        photo = `http://graph.facebook.com/${id}/picture?type=square&access_t`+
            'oken=568040619933060|e39c2101907013523dc22df225edf418';
    }
    return photo;
};

export const User_icon = ({user, white})=>{
    const photo = get_photo(user);
    const user_bg = `url(${photo})`;
    return photo ? <span className="user-icon"
      style={{backgroundImage: user_bg}}/> : white ?
      <div className="user-icon white"/>:
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="36"
        height="36" viewBox="0 0 24 24" style={{marginRight: '10px'}}>
          <path fill="currentColor" d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,
            14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2
            12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1
            12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,
            12C22,6.4717.5,2 12,2Z" />
      </svg>;
};
